import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import deprecated from '@wordpress/deprecated';
/**
 * Internal dependencies
 */

import BlockIcon from '../block-icon';

function BlockCard(_ref) {
  let {
    title,
    icon,
    description,
    blockType
  } = _ref;

  if (blockType) {
    deprecated('`blockType` property in `BlockCard component`', {
      since: '5.7',
      alternative: '`title, icon and description` properties'
    });
    ({
      title,
      icon,
      description
    } = blockType);
  }

  return createElement("div", {
    className: "block-editor-block-card"
  }, createElement(BlockIcon, {
    icon: icon,
    showColors: true
  }), createElement("div", {
    className: "block-editor-block-card__content"
  }, createElement("h2", {
    className: "block-editor-block-card__title"
  }, title), createElement("span", {
    className: "block-editor-block-card__description"
  }, description)));
}

export default BlockCard;
//# sourceMappingURL=index.js.map